<template>
  <div class="control-city">
    <div
      class="control-city-current"
      @click="$city.data.isCityHeaderShown = !$city.data.isCityHeaderShown"
    >
      {{ CITY.name }}
      <chevron-animated :reverse="$city.data.isCityHeaderShown" />
    </div>

    <div class="control-city-confirm">
      <ui-dropdown
        left
        right
        :visible="!CITY_CONFIRMED && !$city.data.isCityHeaderShown"
      >
        <p>
          Ваш регион доставки:
          <br>{{ CITY.name }}?
        </p>
        <div class="buttons">
          <ui-button
            text="Да, верно"
            @click="CONFIRM_CITY"
          />
          <ui-button
            flat
            text="Нет, выбрать другой"
            @click="$city.data.isCityHeaderShown = true"
          />
        </div>
      </ui-dropdown>
    </div>

    <div class="control-city-search">
      <ui-dropdown
        left
        :visible="$city.data.isCityHeaderShown"
        @on-close="$city.data.isCityHeaderShown = false"
      >
        <city-search
          v-if="$city.data.isCityHeaderShown"
          @choose="chooseCity"
        />
      </ui-dropdown>
    </div>

    <client-only>
      <template v-if="!adaptive.isDesktop">
        <modal-confirm
          :visible="!CITY_CONFIRMED && !$city.data.isCityHeaderShown"
          :title="`Ваш регион доставки: <br>${ CITY.name }?`"
          :buttons="[
            {
              text: 'Да, верно',
            // action дергается в close
            },
            {
              text: 'Нет, выбрать другой',
              flat: true,
              action: () => $nav.show('city'),
            },
          ]"
          @on-close="CONFIRM_CITY"
        />
      </template>
    </client-only>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ChevronAnimated from '@/assets/icons/chevron-animated.vue';

export default {
  name: 'control-city',
  components: {
    ChevronAnimated,
    CitySearch: defineAsyncComponent(() => import('./city-search.vue')),
  },
  inject: ['adaptive'],
  computed: {
    ...mapGetters({
      CITY: 'user/city',
      CITY_CONFIRMED: 'user/cityConfirmed',
    }),
  },

  methods: {
    ...mapActions({
      UPDATE_CITY: 'user/updateCity',
    }),

    ...mapMutations({
      CONFIRM_CITY: 'user/cityConfirmed',
    }),

    chooseCity(city) {
      this.$city.requestConfirmation({ city, reloadPage: true });
    },
  },
};
</script>

<style lang="scss">
.control-city {
  // TODO: Исправить на использование БЭМ-селекторов
  // stylelint-disable-next-line selector-max-universal
  > * {
    display: none;

    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    &.modal {
      display: flex;
    }
  }
}

@include breakpoint("desktop") {
  .control-city {
    position: relative;
    margin-left: 33px;

    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    > * {
      display: block;
    }

    &-current {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      padding: 7px;
      cursor: pointer;
      white-space: nowrap;

      svg {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        color: $gray_lu;
      }
    }

    &-confirm,
    &-search {
      position: absolute;

      .ui-dropdown-content {
        padding: 24px 12px 24px 24px;

        .city-search {
          padding-right: 12px;
        }
      }
    }

    &-confirm {
      top: -21px;
      width: 320px;

      p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }

      .buttons {
        display: flex;
        white-space: nowrap;

        // TODO: Исправить на использование БЭМ-селекторов
        // stylelint-disable-next-line selector-max-universal
        > *:not(:first-child) {
          margin-left: 8px;
          flex: auto;
          width: auto;
        }
      }
    }

    &-search {
      top: 32px;
      left: -16px;

      .ui-dropdown-scrollview {
        overflow: auto;
        max-height: none;
      }
    }
  }
}
</style>
